import React from "react";
import drone_lab_icon from "../../assets/image/png/drone_lab_icon.png";
import gallery_image1 from "../../assets/image/png/gallery_image1.png";
import gallery_image2 from "../../assets/image/png/gallery_image2.png";
import gallery_image3 from "../../assets/image/png/gallery_image3.png";
import gallery_image4 from "../../assets/image/png/gallery_image4.png";
import gallery_image5 from "../../assets/image/png/gallery_image5.png";
import { courseTrainers, trainingCoursesData } from "../common/Helper";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";

const DronelabAcademy = () => {
  return (
    <div>
      <h4 className=" fs_37 fw-bold ff_inter color_darkgray">
        About Dronelab Academy
      </h4>
      <div className="d-flex tab_btn custom_width py-2 px-3 gap-3 mt-4 align-items-center rounded-3">
        <img src={drone_lab_icon} alt="drone_lab_icon" />
        <p className="mb-0 fs_17 ff_inter text-white fw-semibold">
          DRONELAB ACADEMY
        </p>
      </div>
      <p className=" fs_17 ff_inter fw-normal color_gray mt-4">
        Dronelab Academy is a premier institution offering comprehensive
        training in drone technology. With expert instructors and
        state-of-the-art facilities, it equips students with skills in drone
        piloting, aerial Inspection, mapping, and Drone Development . Gain
        hands-on experience and knowledge to excel in the rapidly growing field
        of drones.
      </p>
      <h3 className=" fs_21 ff_inter fw-bold color_darkgray mt-5">
        Training Gallery
      </h3>
      <div className="row mt-3">
        <div className="col-md-6 mt-3">
          <img className="w-100" src={gallery_image1} alt="gallery_image1" />
        </div>
        <div className="col-md-6 mt-3">
          <div className="row">
            <div className="col-6">
              <img
                className="w-100"
                src={gallery_image2}
                alt="gallery_image2"
              />
            </div>
            <div className="col-6">
              <img
                className="w-100"
                src={gallery_image3}
                alt="gallery_image3"
              />
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-6">
              <img
                className="w-100"
                src={gallery_image4}
                alt="gallery_image2"
              />
            </div>
            <div className="col-6">
              <img
                className="w-100"
                src={gallery_image5}
                alt="gallery_image3"
              />
            </div>
          </div>
        </div>
      </div>
      <h4 className=" fs_21 ff_inter fw-bold color_darkgray mt-5">
        Courses By Dronelab Acedemy
      </h4>
      <div className="row  mt-2">
        {trainingCoursesData.map((obj, index) => {
          return (
            <>
              <div key={index} className="col-md-6 mt-4">
                <Link to="/courses-details">
                  <img className="w-100" src={obj.image} alt="image" />
                  <div className="bg-white border-1 training_border p-3 rounded-bottom-4">
                    <h4 className=" fs_21 fw-bold ff_inter color_darkgray mb-0">
                      {obj.heading}
                    </h4>
                    <div className="d-flex gap-2 align-items-center pt-3">
                      <img
                        width={15}
                        src={obj.loction_icon}
                        alt="loction_icon"
                      />
                      <p className="mb-0  fs_15 fw-normal ff_inter color_darkgray">
                        {obj.location}
                      </p>
                    </div>
                    <div className="d-flex gap-2 align-items-center pt-1">
                      <img width={15} src={obj.date_icon} alt="loction_icon" />
                      <p className="mb-0 fs_15 fw-normal ff_inter color_darkgray">
                        {obj.date}
                      </p>
                    </div>
                    <div className="d-flex mt-4 justify-content-between align-items-center">
                      <h6 className=" fs_26 fw-bold ff_inter color_blue">
                        {obj.price}
                      </h6>
                      <button className="mb-0 viewall_btn px-2 text-white  py-1 fs_15 fw-medium ff_inter">
                        {obj.addToCart}
                      </button>
                    </div>
                  </div>
                </Link>
              </div>
            </>
          );
        })}
        <h5 className=" fw-bold fs_21 ff_inter color_darkgray mt-5">
          Course Trainers
        </h5>
        <div className="ps-lg-4">
          {courseTrainers.map((obj, index) => {
            return (
              <>
                <div
                  key={index}
                  className="trainer_box bg-white p-sm-4 p-3 mt-5 position-relative"
                >
                  <img
                    width={115}
                    className=" position-absolute d-sm-block d-none bg-white custom_image_poistion"
                    src={obj.image}
                    alt="image"
                  />
                  <div className="d-sm-flex justify-content-between align-items-start">
                    <div className="ps-sm-5 ms-sm-5">
                      <img
                        width={80}
                        className="d-sm-none d-block bg-white custom_image_poistion"
                        src={obj.image}
                        alt="image"
                      />
                      <h5 className=" fs_18 mt-3 mt-sm-0 ff_inter fw-bold color_blue mb-0">
                        {obj.fullName}
                      </h5>
                      <p className=" fs_12 ff_inter color_darkgray mt-2">
                        {obj.position}
                      </p>
                    </div>
                    <button className=" fs_12 ff_inter color_darkgray bg-white rounded-2 border-0 p-2">
                      {obj.experience}
                    </button>
                  </div>
                  <p className=" ff_inter fs_17 color_darkgray fw-normal mt-3">
                    {obj.paragraph}
                  </p>
                </div>
              </>
            );
          })}
        </div>

        <h4 className=" fs_21 ff_inter fw-bold color_darkgray mt-5">
          Infrastructure & Equipments
        </h4>
        <p className=" ff_inter fw-normal color_darkgray fs_17 mt-2">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting,
          remaining essentially unchanged.
        </p>

        <h4 className="fs_21 ff_inter fw-bold color_darkgray mt-5">
          FAQs by Dronelab Academy
        </h4>

        <div className="dronelab_accordion">
          <Accordion className="mt-2 " defaultActiveKey="0">
            <Accordion.Item className="" eventKey="0">
              <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                <li className=" list_style color_blue fs_21"></li>
                <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
                  What is DGCA?
                </p>
              </Accordion.Header>
              <Accordion.Body className="fs_17 ff_inter color_darkgray">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="" eventKey="1">
              <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                <li className=" list_style color_blue fs_21"></li>
                <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
                  What does "DGCA approved drone" mean?
                </p>
              </Accordion.Header>
              <Accordion.Body className="fs_17 ff_inter color_darkgray">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="" eventKey="2">
              <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                <li className=" list_style color_blue fs_21"></li>
                <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
                  What is a dronelab academy?
                </p>
              </Accordion.Header>
              <Accordion.Body className="fs_17 ff_inter color_darkgray">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="" eventKey="2">
              <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                <li className=" list_style color_blue fs_21"></li>
                <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
                  How can I check if a drone is DGCA approved?
                </p>
              </Accordion.Header>
              <Accordion.Body className="fs_17 ff_inter color_darkgray">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="" eventKey="2">
              <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                <li className=" list_style color_blue fs_21"></li>
                <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
                  Can I fly a non-DGCA approved drone in India?
                </p>
              </Accordion.Header>
              <Accordion.Body className="fs_17 ff_inter color_darkgray">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="" eventKey="2">
              <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                <li className=" list_style color_blue fs_21"></li>
                <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
                  Who can attend a drone academy?
                </p>
              </Accordion.Header>
              <Accordion.Body className="fs_17 ff_inter color_darkgray">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="" eventKey="2">
              <Accordion.Header className="fs_17 ff_inter fw-bold color_darkgray">
                <li className=" list_style color_blue fs_21"></li>
                <p className=" fs_17 ff_inter fw-semibold color_darkgray mb-0">
                  Is drone piloting
                </p>
              </Accordion.Header>
              <Accordion.Body className="fs_17 ff_inter color_darkgray">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default DronelabAcademy;
